// Carried inline by waiting-list-form.tsx over there; duplication that exists in the Next
// tree is ported as duplication (PORTING.md U8).
export function extractGithubUsername(github: string | null): string {
  if (!github) return '';
  if (github.includes('github.com')) {
    const parts = github.split('/');
    return parts[parts.length - 1] || github;
  }
  return github;
}
